(function() {
       'use strict';

       angular.module('quantixApp').controller('FSMClientCompanyUploadController',
    		   FSMClientCompanyUploadController);

       FSMClientCompanyUploadController.$inject = [ '$scope', '$http', '$timeout', 'PortfolioTrackerService'];

       function FSMClientCompanyUploadController($scope, $http, $timeout,PortfolioTrackerService) {
    	   
    	   
    	   $scope.successRep = '';
    	   $scope.clientNameList = [];
    	   $scope.selectedclientNameTemp = [];
    	   $scope.errorFlag = false;
    	   $scope.fileError = '';
    	   
    	   $scope.getClientNameList = function() {

   			PortfolioTrackerService.getFSMClientList().then(function(data) {
   				$scope.clientNameList = data;
   			}, function(errordata) {
   				
   			});

   		}

           $scope.uploadFSMClientCompanyFileforuser = function(fileUpload) {
        	  
        	
                        var fd = new FormData();
                        
                        if ($scope.clientNameModel != undefined  ) {

                			$scope.selectedclientNameTemp =$scope.clientNameModel.id;

                		
                        fd.append('file', fileUpload);   
                        fd.append('clientName',$scope.selectedclientNameTemp);
                       
                        $http.post('api/adminScreen/uploadFSMClientComFile', fd, {
                        	transformRequest : angular.identity,
                               headers : {
                                      'Content-Type' : undefined
                               }
                        }).then(function(response) {

                               $scope.fileError = '';
                               $scope.successRep = 'OK';
                             
                        }, function(errordata) {

                               $scope.fileError = 'Oops Something went wrong';
                               $scope.errorFlag = true;
                               
                               $timeout(function(){
                            	   $scope.fileError = '';
                            	   $scope.errorFlag = false;
                               },2000);

                        });
                        }else{
                        	$scope.fileError = 'Please select atleast one Client';
                        	
                        }
                        
                        
                      
                 
           }
           
           
	// method for download template
           
           $scope.exportFSMClientBulkData = function(){
			
			
				$http({
					url : 'api/adminScreen/excelExportForFSMClient',

				
					method : 'POST',
					data : $scope.com,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'FSMClient Company.xlsx');

									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										});
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to
										// document
										anchor.attr({
											href : objectUrl,
											target : '_self',
											download : 'FSMClient Company.xlsx'
										})[0].click();

										anchor.remove();

									}

								}).error(function(error) {

						});

			

           }
           
           $scope.getClientNameList();
       
       }


})();